var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{attrs:{"to":"/maximix"}},[_c('div',{staticClass:"banner d-flex flex-column rounded-xl pt-20 px-3 pb-3"})])}
var staticRenderFns = []

export { render, staticRenderFns }